import { render, staticRenderFns } from "./mukellefsorgu.vue?vue&type=template&id=8f3f6aa6"
import script from "./mukellefsorgu.vue?vue&type=script&lang=js"
export * from "./mukellefsorgu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports